import React, { ReactNode } from 'react';
import styled from 'styled-components';
import Media from 'react-media';
import { themes } from 'kb-shared';

const breakpoints = themes.breakpoints;

const ContentContainer = styled.div`
  ${({ theme }) => theme.grid.pageContainer};
  flex: 1;
`;

const FormContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  @media screen and (max-width: ${themes.breakpoints.largePhonePortrait}) {
    width: 100%;
   }
  }
`;

interface MobileProps {
  mobile?: boolean;
}

interface PageAndTitleProps {
  mobile?: boolean;
}

const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  box-sizing: content-box;
  ${({ mobile }: MobileProps) => `
    padding-left: ${mobile ? '0px' : '60px'};
    padding-right: ${mobile ? '0px' : '60px'};
  `};
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  ${({ mobile }: PageAndTitleProps) => `
    padding-top: 0px;
    flex-direction: ${mobile ? 'column' : 'row'};
    align-items: ${mobile ? 'center' : 'flex-start'};
  `}
`;

const LeftContent = styled.div`
  flex: 3;
  @media screen and (max-width: ${themes.breakpoints.largePhonePortrait}) {
    width: 100%;
  }
`;

const RightContent = styled.div`
  flex: 1;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 18px;
  ${({ mobile }: PageAndTitleProps) => `
    flex-direction: ${mobile ? 'column' : 'row'};
    height: ${mobile ? 'auto' : '100px'};
  `}
`;

export const PageTitle = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  ${themes.fonts.DomaineDisplay};
  color: ${themes.colors.KBNight};
  padding-top: 50px;
  padding-bottom: 30px;
  ${({ mobile }: PageAndTitleProps) => `
    font-size: ${mobile ? '28px' : '36px'};
    max-width: ${mobile ? '350px' : 'auto'};
    padding-bottom: ${mobile ? '15px' : '0px'}
  `};
`;

type Props = {
  title: string | null;
  renderMainContent: (mobile: boolean) => ReactNode | null;
  renderDesktopRightSidebar: () => ReactNode | null;
  renderAboveTitleContent?: (mobile: boolean) => ReactNode | null;
};

type State = {};

class AuthFlowLayout extends React.Component<Props, State> {
  render() {
    const {
      renderAboveTitleContent,
      renderMainContent,
      renderDesktopRightSidebar,
      title
    } = this.props;
    return (
      <ContentContainer>
        {/* Tablet + Mobile treated same at this level */}
        <Media query={{ minWidth: breakpoints.raw.smallDesktop }}>
          {desktop => {
            if (desktop) {
              const hasDesktopRightSidebar = renderDesktopRightSidebar() !== null;
              return (
                <>
                  <TitleContainer>
                    <LeftContent>
                      {renderAboveTitleContent && renderAboveTitleContent(false)}
                      {title && <PageTitle>{title}</PageTitle>}
                    </LeftContent>
                    {hasDesktopRightSidebar && <RightContent />}
                  </TitleContainer>
                  <Content>
                    <LeftContent>
                      <FormContainer>
                        <FormContent>{renderMainContent(false)}</FormContent>
                      </FormContainer>
                    </LeftContent>
                    {hasDesktopRightSidebar && (
                      <RightContent>{renderDesktopRightSidebar()}</RightContent>
                    )}
                  </Content>
                </>
              );
            } else {
              return (
                <RightContent>
                  <TitleContainer mobile>
                    {renderAboveTitleContent && renderAboveTitleContent(true)}
                    {title && <PageTitle mobile>{title}</PageTitle>}
                  </TitleContainer>
                  <Content mobile>
                    <FormContainer>
                      <FormContent mobile>{renderMainContent(true)}</FormContent>
                    </FormContainer>
                  </Content>
                </RightContent>
              );
            }
          }}
        </Media>
      </ContentContainer>
    );
  }
}

export default AuthFlowLayout;
